import { format } from 'date-fns'

export function GetHeaderWithToken(headers = {}, withCredentials = true) {
  headers = headers || {}
  headers['crossDomain'] = headers['crossDomain'] ?? true
  headers['Content-Type'] = headers['Content-Type'] ?? 'application/json'
  headers['X-CSRF'] = headers['X-CSRF'] ?? 1

  const memberId = sessionStorage.getItem('browserUser')
  if (memberId) headers['browseruser'] = memberId

  return {
    headers: headers,
    withCredentials: withCredentials
  }
}

export function GetHeaderWithTokenMultiPart(headers = {}) {
  const config = GetHeaderWithToken(headers, false)
  delete config.headers['Content-Type']
  return config
}

export function objectHasAnyValue(object) {
  return typeof object === 'object' && object !== null
    ? Object.keys(object).some((key) => {
        if (typeof object[key] === 'object' && object[key] !== null) {
          if ('isChecked' in object[key]) {
            return object[key].isChecked
          }

          return objectHasAnyValue(object[key])
        }
        if (key !== '_id') {
          return !!object[key]
        }

        return false
      })
    : false
}

export function parseDate(date, dateFormat) {
  try {
    if (date) {
      const parsedDate = new Date(date.replace('Z', ''))
      if (dateFormat) {
        return format(parsedDate, dateFormat)
      }

      return parsedDate
    }
  } catch (error) {
    return null
  }
}

export function extensionToLowerCase(filename) {
  try {
    const parts = filename.split('.')
    const extIndex = parts.length - 1
    const extension = parts[extIndex].toLowerCase()

    parts[extIndex] = extension

    const newName = parts.join('.')

    return newName
  } catch (error) {
    return filename.toLowerCase()
  }
}

export function removeSpecialCharactersFromStringInVideo(string) {
  const myArr = string.split('.')
  let k = []
  for (var i = 0; i < myArr.length; i++) {
    const noSpaces = myArr[i].replace(/\s+/g, '')
    const desired = noSpaces.replace(/[^\w\s]/gi, '')
    if (i + 1 === myArr.length) {
      k.push(`.${desired}`)
    } else {
      k.push(desired)
    }
  }

  return k.join('')
}
